import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "swiper/css";
const teamMembers = [
  { name: "SENETH", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/seneth.jpg" },
  { name: "SAWANI", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/sawani.jpg" },
  { name: "SAMEERA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/sameera.jpg" },
  { name: "SHANTHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/shantha.jpg" },
  { name: "THILAK", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/thilak.jpg" },
  { name: "SAMANTHI", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/samanthi.jpg" },
  { name: "SAMANTHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/samantha.jpg" },
  { name: "RAJIN", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/rajin.jpg" },
  { name: "NADEEKA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/nadeeka.jpg" },
  { name: "SENA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/sena.jpg" },
  { name: "NIMAL", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/nimal.jpg" },
  { name: "MANISHIA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/manishia.jpg" },
  { name: "MADUSHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/madusha.jpg" },
  { name: "MADAWA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/madawa.jpg" },
  { name: "LAKRAJ", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/lakraj.jpg" },
  { name: "LAHIRU", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/lahiru.jpg" },
  { name: "KUMUDUNI", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/kumuduni.jpg" },
  { name: "JEEWAN", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/jeewan.jpg" },
  { name: "ISTAQ", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/istaq.jpg" },
  { name: "DIMUTHU", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/dimuthu.jpg" },
  { name: "DILUP", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/dilup.jpg" },
  { name: "DARSHANA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/darshana.jpg" },
  { name: "ANUSHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/anusha.jpg" },
  { name: "CHEF NISHANTHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/chef-nishantha.jpg" },
  { name: "KUMARA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/kumara.jpg" },
  { name: "CHANDANA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/chandana.jpg" },
  { name: "CHAMPIKA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/champika.jpg" },
  { name: "ARUNA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/aruna.jpg" },
  { name: "AKILA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/akila.jpg" }
];
const VillaTeam = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            {
    /* Mobile Layout - sm and below */
  }
            <div className="lg:hidden container mx-auto flex flex-col gap-8 px-3 sm:px-5">
                {
    /* Label */
  }
                <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800 text-center">
                    Hiru Villa Hospitality
                </p>

                {
    /* Heading */
  }
                <h2 className="font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl text-center">
                    Das Hiru Villa Team
                </h2>

                {
    /* Carousel */
  }
                <div className="relative mx-auto w-full">
                    <Swiper
    modules={[Autoplay, Navigation]}
    navigation={{
      nextEl: ".villa-team-next-mobile",
      prevEl: ".villa-team-prev-mobile"
    }}
    autoplay={{ delay: 3500, disableOnInteraction: false }}
    loop
    speed={700}
    spaceBetween={12}
    slidesPerView={1}
    breakpoints={{
      640: { slidesPerView: 2, spaceBetween: 16 }
    }}
  >
                        {teamMembers.map((member) => <SwiperSlide key={member.name}>
                                <article className="group overflow-hidden rounded-[16px] bg-[#fbfaf7] shadow-[0_12px_30px_rgba(16,38,26,0.08)]">
                                    <div className="relative aspect-[3/4] overflow-hidden bg-[#f3eee7]">
                                        <img
    src={member.image}
    alt={`${member.name} aus dem Hiru-Villa-Team`}
    className="object-cover transition-transform duration-700 group-hover:scale-105"
    loading="lazy" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} />
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/80 via-transparent to-transparent" />
                                        <h3 className="absolute inset-x-2 bottom-3 text-center font-mulish text-xs font-semibold tracking-[0.15em] text-white sm:text-sm">
                                            {member.name}
                                        </h3>
                                    </div>
                                </article>
                            </SwiperSlide>)}
                    </Swiper>

                    <button
    type="button"
    className="villa-team-prev-mobile absolute left-0 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white"
    aria-label="Vorheriges Teammitglied"
    title="Vorheriges Teammitglied"
  >
                        <FiChevronLeft className="h-4 w-4" aria-hidden="true" />
                    </button>
                    <button
    type="button"
    className="villa-team-next-mobile absolute right-0 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white"
    aria-label="Nächstes Teammitglied"
    title="Nächstes Teammitglied"
  >
                        <FiChevronRight className="h-4 w-4" aria-hidden="true" />
                    </button>
                </div>

                {
    /* Description */
  }
                <div className="space-y-3 text-center">
                    <p className="font-mulish text-[15px] leading-7 text-gray-700 sm:text-base">
                        Der Stolz von Hiru Villa ist das engagierte Team, das Sie wie eine Familie herzlich willkommen heißt. Von erfahrenen Ayurveda-Ärzten über geschulte Therapeuten und Köche bis hin zu Hauspersonal und Gärtnern – alle sorgen mit Hingabe dafür, dass Sie sich wohl fühlen.
                    </p>
                    <p className="font-mulish text-[15px] leading-7 text-gray-700 sm:text-base">
                        Für uns geht Service weit über die reine Betreuung hinaus. Wir begleiten Sie auf Ihrer Reise, damit Sie Körper und Geist tief entspannen und zu sich selbst zurückfinden. Unser freundliches Team erwartet Sie an der schönen Küste von Maggona mit einem Lächeln.
                    </p>
                </div>
            </div>

            {
    /* Desktop Layout - lg and above */
  }
            <div className="hidden lg:block">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="mx-auto max-w-4xl text-center">
                        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                            Hiru Villa Hospitality
                        </p>
                        <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Das Hiru Villa Team
                        </h2>
                        <p className="mt-6 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                            Der Stolz von Hiru Villa ist das engagierte Team, das Sie wie eine Familie herzlich willkommen heißt. Von erfahrenen Ayurveda-Ärzten über geschulte Therapeuten und Köche bis hin zu Hauspersonal und Gärtnern – alle sorgen mit Hingabe dafür, dass Sie sich wohl fühlen.
                        </p>
                        <p className="mt-5 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                            Für uns geht Service weit über die reine Betreuung hinaus. Wir begleiten Sie auf Ihrer Reise, damit Sie Körper und Geist tief entspannen und zu sich selbst zurückfinden. Unser freundliches Team erwartet Sie an der schönen Küste von Maggona mit einem Lächeln.
                        </p>
                    </div>

                    <div className="relative mx-auto mt-12 max-w-7xl px-10 sm:px-12 lg:px-14">
                        <Swiper
    modules={[Autoplay, Navigation]}
    navigation={{
      nextEl: ".villa-team-next-desktop",
      prevEl: ".villa-team-prev-desktop"
    }}
    autoplay={{ delay: 3500, disableOnInteraction: false }}
    loop
    speed={700}
    spaceBetween={16}
    slidesPerView={1}
    breakpoints={{
      640: { slidesPerView: 2, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 24 }
    }}
  >
                            {teamMembers.map((member) => <SwiperSlide key={member.name}>
                                    <article className="group overflow-hidden rounded-[20px] bg-[#fbfaf7] shadow-[0_18px_45px_rgba(16,38,26,0.1)]">
                                        <div className="relative aspect-[3/4] overflow-hidden bg-[#f3eee7]">
                                            <img
    src={member.image}
    alt={`${member.name} aus dem Hiru-Villa-Team`}
    className="object-cover transition-transform duration-700 group-hover:scale-105"
    loading="lazy" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} />
                                            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/80 via-transparent to-transparent" />
                                            <h3 className="absolute inset-x-3 bottom-4 text-center font-mulish text-sm font-semibold tracking-[0.2em] text-white sm:text-base">
                                                {member.name}
                                            </h3>
                                        </div>
                                    </article>
                                </SwiperSlide>)}
                        </Swiper>

                        <button
    type="button"
    className="villa-team-prev-desktop absolute left-0 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white"
    aria-label="Vorheriges Teammitglied"
    title="Vorheriges Teammitglied"
  >
                            <FiChevronLeft className="h-5 w-5" aria-hidden="true" />
                        </button>
                        <button
    type="button"
    className="villa-team-next-desktop absolute right-0 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white"
    aria-label="Nächstes Teammitglied"
    title="Nächstes Teammitglied"
  >
                            <FiChevronRight className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        </section>;
};
export default VillaTeam;
